import React from 'react';
// import { useQuery } from '@apollo/client';
// import { OFFERS_QUERY } from 'utils/CommonGraphQL';
// import Loader from 'components/common/Loader';
import BiddingDetails from 'components/BiddingDetails';
import BiddingForwardDetails from 'components/BiddingForwardDetails';
import BiddingForeignDetails from 'components/BiddingForeignDetails';

const BiddingOfferDetails = ({ id, bidType, bidOfferType }) => {
  // const { data, loading, error } = useQuery(OFFERS_QUERY, {
  //   variables: {
  //     filter: [{ key: 'id', value: id, type: 'INT', op: 'EQ' }],
  //   },
  // });
  // if (error) return `There is an error on this page : ${error.message} `;
  // if (!data?.offers?.offers) return 'Offers not available';
  // if (loading) return <Loader />;
  // console.log('bidOfferType sdfgh', bidOfferType, id, bidType);
  return (
    <div className="bidding-detail-mobile">
      {' '}
      {bidOfferType === 'FORWARD' && (
        <BiddingForwardDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidOfferType}
        />
      )}
      {bidOfferType === 'LIVE' && (
        <BiddingDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidOfferType}
          // currentRow={data?.offers?.offers[0]}
        />
      )}
      {bidOfferType === 'FOREIGN' && (
        <BiddingForeignDetails
          id={id}
          bidType={bidType}
          bidOfferAndDemandType={bidOfferType}
        />
      )}
    </div>
  );
};

export default BiddingOfferDetails;
